import { TableDateCell } from '../../Table'

function ChatTableRowLastMessageDate({ item, ...restProps }) {
  const { last_message: lastMessage } = item

  return <TableDateCell {...restProps} value={lastMessage?.created} />
}

export default ChatTableRowLastMessageDate
